import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./SignUpBanner.scss";
import DstButton from "../DstButton/DstButton";

const SignUpBanner = () => {
  return (
    <section className="container-fluid py-5 my-5" id="sign-up-banner">
      <Container>
        <div className="bg-neon-orange p-4 px-md-5 rounded-plus">
          <Row className="g-4 align-items-center">
            <Col xs={12} lg={6} className="order-1 order-lg-0">
              <h2 className="h3 text-white mb-3">
                Découvrez la formation qu'il vous faut !
              </h2>

              <p className="font-m text-white mb-4">
                Répondez en 2 minutes au questionnaire orientation pour révéler
                le métier de la Tech fait pour vous.
              </p>

              <DstButton
                value="Testez votre éligibilité"
                variant="outline-light"
                link="https://formation.datascientest.com/questionnaire-profil-tech"
                target="_blank"
              />
            </Col>

            <Col xs={12} lg={6} className="order-0 order-lg-1 text-center">
              <Image
                src="/assets/femme-assise-canape.jpg"
                alt="Femme travaillant sur son ordinateur"
                fluid
                className="img-banner"
              />
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default SignUpBanner;
